"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createDomElementFromHtml(html) {
    var temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.firstElementChild;
}
exports.default = createDomElementFromHtml;
//# sourceMappingURL=createDomElementFromHtml.js.map


//////////////////
// WEBPACK FOOTER
// /Volumes/Eoo/Repositories/legance/wp-content/themes/legance/node_modules/easydropdown/dist/Shared/Util/createDomElementFromHtml.js
// module id = 77
// module chunks = 0